import React from 'react'

export const Progress = ({ width }) => (
  <div className="progress-container">
    <div className="progress-bar" style={{ width }} />
  </div>
)
